import { useContext } from 'react';

import TrackingContext from './TrackingContext';

const useTrackingContext = () => useContext(TrackingContext);

export default useTrackingContext;
